<template>
  <b-modal
    v-model="isModalOpened.isOpen"
    ok-title="Create"
    title="Add new designer section"
    :ok-disabled="!sectionName.length"
    @ok="onOkClick"
  >
    <b-form-group label="Section name">
      <b-form-input
        v-model="sectionName"
        placeholder="Please type new section title"
      />
    </b-form-group>
    <b-form-checkbox v-model="isSectionNameHidden">
      Hide section
    </b-form-checkbox>
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {
  mapState: designerMapState,
  mapActions: designerMapActions,
} = createNamespacedHelpers('designer');
export default {
  name: 'AddNewDesignerSectionModal',
  data() {
    return {
      sectionName: '',
      isSectionNameHidden: false,
    };
  },
  computed: {
    ...designerMapState({
      isModalOpened: state => state.addEditSectionModal,
    }),
  },
  methods: {
    ...designerMapActions(['addNewSection']),
    onOkClick() {
      this.addNewSection({
        name: this.sectionName,
        isHidden: this.isSectionNameHidden,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.color__picker {
  width: 50%;
}

</style>